import script from "./AgGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./AgGrid.vue?vue&type=script&setup=true&lang=js"

import "./AgGrid.vue?vue&type=style&index=0&id=e9d0e636&lang=scss"

const __exports__ = script;

export default __exports__